<template>
  <div>
    <nav>
      <div class="logo-nav">
        <img alt="Agritest Logo" src="@/assets/images/logo.png" />
      </div>
    </nav>

    <div class="interface">
      <img class="image" src="@/assets/images/fundo.jpg" alt="Fundo" />
      <div class="image-overlay"></div>
      <b-card class="forgot-card">
        <div class="forgot-card-content">
          <!-- Success State -->
          <div v-if="emailSent" class="success-state">
            <div class="success-icon">
              <i class="fas fa-check-circle"></i>
            </div>
            <h2 class="title">Email Enviado!</h2>
            <p class="message">
              Se o email <strong>{{ email }}</strong> estiver cadastrado em nosso sistema,
              você receberá um link para redefinir sua senha.
            </p>
            <p class="hint">Verifique também sua caixa de spam.</p>
            <router-link to="/login" class="btn-back">
              <i class="fas fa-arrow-left"></i>
              <span>Voltar ao Login</span>
            </router-link>
          </div>

          <!-- Form State -->
          <b-form v-else @submit.prevent="submitForgotPassword">
            <div class="forgot-header">
              <div class="header-icon">
                <i class="fas fa-lock"></i>
              </div>
              <h2 class="title">Esqueceu sua senha?</h2>
              <p class="subtitle">
                Não se preocupe! Digite seu email abaixo e enviaremos um link para você redefinir sua senha.
              </p>
            </div>

            <div class="form-group">
              <label class="label">
                <i class="fas fa-envelope label-icon"></i>
                Email
              </label>
              <b-form-input
                v-model="email"
                type="email"
                placeholder="seuemail@exemplo.com"
                autocomplete="email"
                name="email"
                required
                class="modern-input"
                :disabled="loading"
              ></b-form-input>
            </div>

            <b-button class="btn-submit" type="submit" :disabled="loading || !email">
              <b-spinner v-if="loading" small class="mr-2"></b-spinner>
              <span v-if="loading">Enviando...</span>
              <template v-else>
                <span>Enviar Link de Recuperação</span>
                <i class="fas fa-paper-plane"></i>
              </template>
            </b-button>

            <div class="back-link">
              <router-link to="/login">
                <i class="fas fa-arrow-left"></i>
                Voltar ao Login
              </router-link>
            </div>
          </b-form>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { request } from '@/services'
import { DB_ROUTES } from '../constants'

export default {
  name: 'ForgotPassword',
  data: () => ({
    email: '',
    loading: false,
    emailSent: false
  }),
  methods: {
    submitForgotPassword () {
      this.loading = true
      request.post(
        DB_ROUTES.FORGOT_PASSWORD,
        { Email: this.email },
        () => {
          this.loading = false
          this.emailSent = true
        },
        error => {
          this.loading = false
          console.error('Forgot password error:', error)
          // Even on error, show success to prevent email enumeration
          this.emailSent = true
        }
      )
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../style/colors.styl'
@import '../style/fonts.styl'
@import '../style/spacing.styl'

.logo-nav
  padding-left 85px

nav
  position relative
  z-index 2
  background-color secondary
  box-shadow shadow-md
  height 100px
  display flex
  align-items center

.interface
  min-height calc(100vh - 100px)
  display flex
  align-items center
  justify-content center
  background-color secondary
  position relative
  overflow hidden

.image
  width 100%
  height 100%
  object-fit cover
  position absolute
  top 0
  left 0
  z-index 1

.image-overlay
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  background linear-gradient(135deg, rgba(255, 140, 66, 0.7) 0%, rgba(28, 78, 122, 0.8) 100%)
  z-index 2
  backdrop-filter blur(2px)

.forgot-card
  position relative
  z-index 3
  width 480px
  max-width 90%
  background linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)
  border-radius radius-2xl
  box-shadow 0 20px 60px rgba(0, 0, 0, 0.3)
  border none
  padding 0
  animation fadeInUp 0.6s ease-out

@keyframes fadeInUp
  from
    opacity 0
    transform translateY(30px)
  to
    opacity 1
    transform translateY(0)

.forgot-card-content
  padding space-2xl

.card-body
  padding 0

.forgot-header
  text-align center
  margin-bottom space-xl

.header-icon
  width 80px
  height 80px
  margin 0 auto space-lg
  background linear-gradient(135deg, primary 0%, #FF7A29 100%)
  border-radius 50%
  display flex
  align-items center
  justify-content center
  box-shadow shadow-orange

  i
    font-size 2rem
    color white

.title
  font-size 1.75rem
  font-weight 700
  background linear-gradient(135deg, primary 0%, accent 100%)
  -webkit-background-clip text
  -webkit-text-fill-color transparent
  background-clip text
  margin-bottom space-sm

.subtitle
  color #6c757d
  font-size 0.95rem
  margin 0
  line-height 1.5

.form-group
  margin-bottom space-xl

.label
  display flex
  align-items center
  font-weight 600
  color #2c3e50
  margin-bottom space-sm
  font-size 0.95rem

.label-icon
  margin-right space-xs
  color primary
  font-size 0.9rem

.modern-input
  height 50px
  border 2px solid #e0e0e0
  border-radius radius-lg
  padding 0 space-md
  font-size 1rem
  transition all transition-base
  background-color white

  &:focus
    border-color primary
    box-shadow 0 0 0 4px rgba(255, 140, 66, 0.1)
    background-color white

  &::placeholder
    color #aaa

  &:disabled
    background-color #f5f5f5
    cursor not-allowed

.btn-submit
  width 100%
  height 54px
  background linear-gradient(135deg, primary 0%, #FF7A29 100%)
  border none
  border-radius radius-lg
  font-weight 600
  font-size 1.05rem
  display flex
  align-items center
  justify-content center
  gap space-sm
  transition all transition-base
  box-shadow shadow-orange
  color white
  margin-bottom space-lg

  &:hover:not(:disabled)
    background linear-gradient(135deg, #FF7A29 0%, #FF6810 100%)
    transform translateY(-2px)
    box-shadow shadow-orange-lg
    color white

  &:active
    transform translateY(0)

  &:disabled
    opacity 0.7
    cursor not-allowed
    transform none

  i
    transition all transition-fast

  &:hover:not(:disabled) i
    transform translateX(4px)

.back-link
  text-align center

  a
    color accent
    text-decoration none
    font-weight 500
    display inline-flex
    align-items center
    gap space-xs
    transition all transition-fast

    &:hover
      color primary
      text-decoration underline

    i
      font-size 0.85rem

// Success State Styles
.success-state
  text-align center

.success-icon
  width 100px
  height 100px
  margin 0 auto space-lg
  background linear-gradient(135deg, success 0%, #3D7A5C 100%)
  border-radius 50%
  display flex
  align-items center
  justify-content center
  animation scaleIn 0.5s ease-out

  i
    font-size 3rem
    color white

@keyframes scaleIn
  from
    transform scale(0)
    opacity 0
  to
    transform scale(1)
    opacity 1

.message
  color #495057
  font-size 1rem
  line-height 1.6
  margin-bottom space-md

  strong
    color accent

.hint
  color #6c757d
  font-size 0.9rem
  margin-bottom space-xl

.btn-back
  display inline-flex
  align-items center
  justify-content center
  gap space-sm
  padding space-md space-xl
  background linear-gradient(135deg, accent 0%, accent-hover 100%)
  color white
  text-decoration none
  border-radius radius-lg
  font-weight 600
  transition all transition-base

  &:hover
    background linear-gradient(135deg, accent-hover 0%, #3670A0 100%)
    transform translateY(-2px)
    color white
    text-decoration none

  i
    font-size 0.9rem

// Responsive
@media (max-width: 680px)
  .forgot-card
    width 95%

  .forgot-card-content
    padding space-xl space-lg

  .logo-nav
    padding-left 20px

  nav
    height 80px

  .title
    font-size 1.5rem

  .header-icon
    width 70px
    height 70px

    i
      font-size 1.75rem

  .success-icon
    width 80px
    height 80px

    i
      font-size 2.5rem
</style>
